// Modules
import React from "react";
import PropTypes from "prop-types";
import Skeleton from "@material-ui/lab/Skeleton";

// Assets
import "./table.scss";

const Table = (props) => {
	const {
		header,
		rows,
		colNb,
		loader,
		clssName,
		// Can either be "empty" or "table"
		aspect,
		split,
	} = props;

	return (
		split === true ?
			(
				<div className={`custom-table-container splitted ${clssName}`}>
					<h6>{header}</h6>
					<div className="table-splitted-container">
						<table
							className={`custom-table-container ${aspect}`}
							border={0}
							cellSpacing={0}
							cellPadding={0}
						>
							<tbody>
								{rows.map((row, index) => {
									if (index <= rows.length / 2)
										return (
											<tr key={index}>
												<td className="title-cat">
													{loader === true
														? <Skeleton variant="text" animation="wave" className="title-cat" width="5vh" />
														: row.name}
												</td>
												<td className="descr">
													{loader === true
														? <Skeleton variant="text" animation="wave" className="descr" style={{ paddingRight: "0", maxWidth: "unset" }} />
														: row.value}
												</td>
											</tr>
										);
									return null;
								})}
							</tbody>
						</table>
						<table
							className={`custom-table-container ${aspect}`}
							border={0}
							cellSpacing={0}
							cellPadding={0}
						>
							<tbody>
								{rows.map((row, index) => {
									if (index > rows.length / 2)
										return (
											<tr key={index}>
												<td className="title-cat">
													{loader === true
														? <Skeleton variant="text" animation="wave" className="title-cat" width="5vh" />
														: row.name}
												</td>
												<td className="descr">
													{loader === true
														? <Skeleton variant="text" animation="wave" className="descr" style={{ paddingRight: "0", maxWidth: "unset" }} />
														: row.value}
												</td>
											</tr>
										);
									return null;
								})}
							</tbody>
						</table>
					</div>
				</div>
			) : (
				<table
					className={`custom-table-container ${clssName} ${aspect}`}
					border={0}
					cellSpacing={0}
					cellPadding={0}
				>
					{
						header
							? (
								<thead>
									<tr>
										<th colSpan={colNb}>{header}</th>
									</tr>
								</thead >
							) : null}
					<tbody>
						{rows.map((row, index) => (
							<tr key={index}>
								<td className="title-cat">
									{loader === true
										? <Skeleton variant="text" animation="wave" className="title-cat" width="5vh" />
										: row.name}
								</td>
								<td className="descr">
									{loader === true
										? <Skeleton variant="text" animation="wave" className="descr" style={{ paddingRight: "0", maxWidth: "unset" }} />
										: row.value}
								</td>
							</tr>
						))}
					</tbody>
				</table >)
	);
};

Table.propTypes = {
	header: PropTypes.string,
	rows: PropTypes.arrayOf(
		PropTypes.shape({
			name: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
			value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
			key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		})
	).isRequired,
	colNb: PropTypes.number,
	loader: PropTypes.bool.isRequired,
	clssName: PropTypes.string,
	aspect: PropTypes.string,
	split: PropTypes.bool,
};

Table.defaultProps = {
	header: null,
	colNb: 2,
	clssName: "",
	aspect: "empty",
	split: false,
};

export default Table;